export const home_menus = [{}]
